<template>
  <a-layout-content v-if="data.length !== 0">
    <div v-if="pageLoading === false">
      <a-row :gutter="8">
        <a-col :xs="{span:24}">
          <a-card :loading="pageLoading" class="m-bottom">
            <div slot="title">Manifest Realisasi Lembur</div>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Pembuatan | Pembuat</span>
                <span class="list-desc">{{data.header.create_dt}} | {{ data.header.tlc_create }}</span>
              </li>
              <li>
                <span class="list-title" for>Nomor SPL</span>
                <span class="list-desc">{{data.header.no_realisasi_spl}}</span>
              </li>
              <li>
                <span class="list-title" for>Atas Perintah</span>
                <span class="list-desc">{{data.header.commander}}</span>
              </li>
              <li>
                <span class="list-title" for>Pelaksana</span>
                <span class="list-desc">{{data.header.pelaksana}}</span>
              </li>
              <li>
                <span class="list-title" for>Kode Proyek</span>
                <span class="list-desc">{{data.header.c_proyek}}</span>
              </li>
              <li>
                <span class="list-title" for>Uraian Tugas</span>
                <span class="list-desc">{{data.header.uraian}}</span>
              </li>
            </ul>
          </a-card>

          <a-card class="m-top d-flex flex-column nowrap" title="Detil Lembur">
            <a-list :grid="{ gutter: 16,lg: 1 }" :dataSource="data.jadwal_pekerjaan" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <!-- <div slot="title" class="d-flex justify-between">
                    <span class="list-title">TLC</span>
                    <a-tag>{{item.c_proyek}}</a-tag>
                  </div> -->
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <table style="width:100%">
                        <tr >
                          <td>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="isMobile ? 12: 4">
                                <div :class="isMobile ? 'head-dtl-lembur' : ''" style="width:100%">
                                <a-avatar
                                :size="isMobile ? 24 : 52"
                                :class="isMobile ? 'avatar-dtl-lembur' : ''"
                                >{{ index + 1 }}</a-avatar>
                                </div>
                              </a-col>
                              <a-col :xs="24" :lg="isMobile ? 12 : 20">
                                <a-row :gutter="16" :class="isMobile ? 'm-top' : ''">
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Tanggal</span>
                                      <span class="list-desc">{{ item.date }}</span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Estimasi Waktu</span>
                                      <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{ moment(item.end_time).format("HH:mm") }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                                <a-row :gutter="16">
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">TLC Pelaksana</span>
                                      <span class="list-desc">{{ item.pelaksana }}</span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Lokasi Lembur</span>
                                      <span class="list-desc">{{ item.lokasi }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                              </a-col>
                            </a-row>
                          </td>
                        </tr>
                      </table>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
          </a-card>
          <a-card class="m-top d-flex flex-column nowrap" title="Detil Realisasi Lembur">
            <a-form class="m-form" :form="formEditHRD">
            <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="data.detail_realisasi" :pagination="pagination2">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <!-- <div slot="title" class="d-flex justify-between">
                  <span class="list-title">TLC</span>
                  <a-tag>{{item.c_proyek}}</a-tag>
                </div> -->
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <table style="width:100%">
                        <tr >
                          <td>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="3">
                                <div :class="isMobile ? 'head-dtl-lembur' :''" style="width:100%">
                                <a-avatar
                                :size="isMobile? 24 : 52"
                                :class="isMobile ? 'avatar-dtl-lembur' : ''"
                                >{{ index + 1 }}</a-avatar>
                                </div>
                              </a-col>
                              <a-col :xs="24" :lg="12">
                                <a-row :gutter="8" :class="isMobile ? 'm-top' : ''">
                                  <a-col :xs="24" :lg="14">
                                    <li class="m-remove">
                                      <span class="list-title">Tanggal</span>
                                      <span class="list-desc">{{ item.start_time ? moment(item.start_time).format(getDefaultDateFormat) : '-' }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu Sistem</span>
                                      <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{ moment(item.end_time).format("HH:mm") }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu Manual</span>
                                      <span class="list-desc">{{ moment(item.start_time_usr).format("HH:mm") }} s.d {{ moment(item.end_time_usr).format("HH:mm") }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu HRD</span>
                                      <span class="list-desc" v-if="editingRealisasi && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id">
                                        <a-form-item>
                                          <a-time-picker v-decorator="[
                                            'start_realisasi_hrd'+ item.realisasi_spl_dtl_id,
                                            {
                                              rules: [{ required: true, message: 'Realisasi Awal is required!' }], initialValue: modalEditHRD.start_realisasi_hrd,
                                            },
                                          ]" format="HH:mm" placeholder="Awal" class="w-full" />  
                                        </a-form-item>
                                        <a-form-item>
                                          <a-time-picker v-decorator="[
                                            'end_realisasi_hrd' + item.realisasi_spl_dtl_id,
                                            {
                                              rules: [{ required: true, message: 'Realisasi Akhir is required!' }], initialValue: modalEditHRD.end_realisasi_hrd,
                                            },
                                          ]" format="HH:mm" placeholder="Akhir" class="w-full m-top" />
                                        </a-form-item>
                                      </span>
                                      <span class="list-desc" v-else>
                                        {{ item.start_time_hrd ? moment(item.start_time_hrd).format("HH:mm") : "-" }} s.d {{ item.end_time_hrd ? moment(item.end_time_hrd).format("HH:mm") : "-" }}
                                      </span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="10">
                                    <li class="m-remove">
                                      <span class="list-title">TLC Pelaksana</span>
                                      <span class="list-desc">{{ item.pelaksana }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ realisasijam(item.start_time, item.end_time) }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ realisasijam(item.start_time_usr, item.end_time_usr) }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ item.start_time_hrd && item.end_time_hrd ? realisasijam(item.start_time_hrd, item.end_time_hrd) : "-" }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                                <a-row>
                                  <a-col>
                                    <li class="m-remove">
                                      <span class="list-title">Catatan</span>
                                      <span class="list-desc">{{ item.catatan }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                              </a-col>
                              <a-col :xs="24" :lg="9">
                                <a-table
                                  :key="'log'+ index"
                                  :rowKey="(record, index) => {return index;}"
                                  :columns="columnslogHistory"
                                  :dataSource="item.log_absen"
                                  :pagination="false"
                                  :scroll="{ y: 100 }"
                                  size="small"
                                  bordered
                                  :class="isMobile ? 'm-top' : ''"
                                >
                                  <template slot="no" slot-scope="value, item, index">
                                    {{ (index + 1) }}
                                  </template>
                                </a-table>
                                  <a-button v-if="isHRD && data.jenis=='Approve'" 
                                  :loading="loadingSavetimeHrd && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id" :type="item.start_time_hrd!=null ? 'primary' : 'danger'" 
                                  class="w-full m-top" @click="editRealisasi(item)">
                                  {{ editingRealisasi && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id ? 'Simpan' : 'Edit Realisasi Waktu HRD' }}
                                  </a-button>
                              </a-col>
                            </a-row>
                          </td>
                        </tr>
                      </table>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
            </a-form>
          </a-card>

          <a-collapse class="m-top" activeKey="0">
            <a-collapse-panel key="0">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="m-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{data.user_pembuat.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4 class="m-remove">{{data.user_pembuat.tanggal}}</h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{data.user_pembuat.status}}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'red' : workflow.status === 'Waiting' ? 'grey' : 'green'"
                >
                  <div
                    class="m-timeline-title"
                  >{{workflow.actor === null ? workflow.jenis : workflow.actor}} {{workflow.tlc ? ' - ' + workflow.tlc : ''}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="m-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{workflow.remark}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="m-top"
            :loading="pageLoading"
            v-if="data.jenis.toLowerCase() === 'approve'"
          >
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Password">
                <a-input
                  type="password"
                  placeholder="Password"
                  v-decorator="['password', {rules: [{required: true}]}]"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button :loading="loadingApprove" @click="handleSubmit" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      },
      pagination2: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      },
      loadingApprove: false,
      editingRealisasi: false,
      columnslogHistory: [
        {
          title: "#",
          scopedSlots: { customRender: "no" },
          align: "right",
          width: "35px"
        },
        {
          title: "Log. Absensi",
          dataIndex: "timestamp",
          align: "center",
        },
      ],
      loadingSavetimeHrd: false,
      modalEditHRD: {
        realisasi_spl_dtl_id: ""
      },
      is_hrd: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEditHRD  = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleSubmitProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSubmitProcess);
  },
  computed: {
    ...mapGetters(["getScreen","getDefaultDateFormat"]),
    isHRD() {
      return this.is_hrd=='1' ? true : false
    }
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_realisasi_spl",
        params: {
          id: this.id
        }
      })
        .then(response => {
          console.log(response);
          this.data = {
            header: response.data.header[0],
            actor: response.data.tlc,
            id: response.data.id_manifest,
            jenis: response.data.jenis,
            last_status: response.data.status_app[response.data.status_app.length-1].status,
            user_pembuat: {
              tlc: response.data.header[0].tlc_create,
              tanggal: response.data.header[0].create_dt,
              status: "Created"
            },
            status: response.data.status_app,
            aksi: response.data.aksi,
            jadwal_pekerjaan: response.data.jadwal_pekerjaan,
            detail_realisasi: response.data.detail_realisasi
          };
          this.is_hrd = response.data.is_hrd
          this.pageLoading = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan system, error code 404!"
            });
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.confirmMessage("confirm-save");
    },
    handleSubmitProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.$notification.error({
            message: "Error",
            description: "Pilih Aksi Terlebih Dahulu!"
          });
          return;
        }

        let hrddata = _.filter(this.data.detail_realisasi, (el) => el.start_time_hrd == null || el.end_time_hrd == null)
          if (values.aksi=="Approved" && hrddata.length > 0) {
            this.displayMessageValue("error-basic", "Masih ada Realisasi Waktu HRD yang belum terisi!");
            return
          }

        let postData = new FormData();

        postData.append("realisasi_id", this.data.id);
        postData.append("status", values.aksi);
        postData.append("remark", values.catatan ? values.catatan : "");
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        this.loadingApprove = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_realisasi_spl",
          processData: false,
          data: postData
        })
          .then(response => {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil diproses!"
            });
            this.loadingApprove = false;
            this.$router.go();
          })
          .catch(err => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.$notification.error({
                message: "Error",
                description: err.response.data.message
              });
            }
            this.loadingApprove = false;
          });
      });
    },
    realisasijam(start, end) {
      let result = ""
      start = moment(start)
      end = moment(end)
      let durasi = moment.duration(end.diff(start));
      result = durasi.hours() + " jam " + durasi.minutes() + " menit"
      return result
    },
    editRealisasi(val) {
      if (this.modalEditHRD.realisasi_spl_dtl_id=="") {
        this.modalEditHRD.realisasi_spl_dtl_id = val.realisasi_spl_dtl_id
        this.modalEditHRD.start_realisasi_hrd = val.start_time_hrd
        this.modalEditHRD.end_realisasi_hrd = val.end_time_hrd
        this.editingRealisasi = true
      } else {
        let start = this.formEditHRD.getFieldValue('start_realisasi_hrd' + val.realisasi_spl_dtl_id);
        let end = this.formEditHRD.getFieldValue('end_realisasi_hrd' + val.realisasi_spl_dtl_id);
        if (start && end) {
          start = moment(val.spl_dt + " " + moment(start).format("HH:mm:ss")).format("YYYY-MM-DD HH:mm:ss")
          end = moment(val.spl_dt + " " + moment(end).format("HH:mm:ss")).format("YYYY-MM-DD HH:mm:ss")

          let post = new FormData();
          post.append("start_date", start);
          post.append("end_date", end);
          post.append("realisasi_spl_dtl_id", val.realisasi_spl_dtl_id);

          this.loadingSavetimeHrd = true
          axios({
            method: "post",
            url: this.$serviceUrl + "public_manifest/verifikasi_hrd",
            processData: false,
            data: post,
            auth: {},
            headers: {}
          })
            .then(() => {
              let index = _.findIndex(this.data.detail_realisasi, (el) => el.realisasi_spl_dtl_id == val.realisasi_spl_dtl_id)
              this.data.detail_realisasi[index].start_time_hrd = start
              this.data.detail_realisasi[index].end_time_hrd = end

              this.modalEditHRD.realisasi_spl_dtl_id = ""
              this.modalEditHRD.start_realisasi_hrd = ""
              this.modalEditHRD.end_realisasi_hrd = ""
              this.editingRealisasi = false
              this.loadingSavetimeHrd = false
              this.displayMessage("success-save");
            })
            .catch((err) => {
              this.loadingSavetimeHrd = false
              console.log(err)
              if (err.message) {
                this.displayMessageValue("error", err.message);
              } else {
                let responses = Object.assign({}, err);
                this.displayMessageValue("error", responses);
              }
            });
        } else {
          this.displayMessageValue("error-basic", "Waktu Awal dan Akhir harus diisi!");
        }
      }
    },
  }
};
</script>

<style>
</style> 